import {gql} from "@apollo/client";
import {ReferralInquiryInput} from "../domain";
import {getDomainGraphqlError, useMutation$} from "graphqlsupport";
import {useCallback} from "react";
import {showToast} from "common";


const GRAPHQL_MUTATION = gql`
mutation submitReferralInquiry($input: ReferralInquiryInput) {
    submitReferralInquiry(input: $input) {
        guid
    }
}`;

type ReferralInquiryInputWithReferral = ReferralInquiryInput & {
    referralGuid: string;
}

export function useReferralInquiry(referralGuid: string) {
    const {execute,} = useMutation$<{ input: ReferralInquiryInputWithReferral }, void>(GRAPHQL_MUTATION);
    const submitReferralInquiry = useCallback(async function (formValues: ReferralInquiryInput | null) {
        if (formValues == null) {
            return;
        }

        try {
            await execute({
                variables: {
                    input: {
                        ...formValues,
                        referralGuid,
                    },
                }
            });
            showToast.success('Referral Inquiry request successfully submitted.');
        } catch (errors: any) {
            if (getDomainGraphqlError(errors)) {
                showToast.error(getDomainGraphqlError(errors));
            } else {
                showToast.error(`Unable to submit reason by ${errors.message || errors[0].message}`);
            }
        }
    }, [referralGuid, execute]);

    return {
        submitReferralInquiry
    }
}
